module.exports = __webpack_public_path__ + "media/components/signup/static/extend-7757b56c4f5da23af09d710c7785e1b4.svg";